import React from 'react';
import cx from 'classnames';

import { SiteConfigManager } from '@atlas/core';
import { Label } from '@atlas/ui';

const SearchPrompt = () => {
  const view = SiteConfigManager.getConfig('config.config.sportsbook.mobileGridViewType');

  const className = cx('search-prompt', {
    simplified: view === 'simplified',
  });

  return (
    <div className={className}>
      <Label className="label" message={'sportsbook_search_enter_at_least'} />
      <Label className="description" message={'sportsbook_search_to_find_enter'} />
    </div>
  );
};

export default SearchPrompt;
